import { useContext, useState } from 'react'
import { AppContext } from '../../../Context';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Marquee from "react-fast-marquee";

import Cats from "../../components/product/Cats";
import Product from "../../components/product/Product";

export default function MainList({ data }) {

    const { t } = useTranslation();
    const {siteData} = useContext(AppContext); 
    const [siteInfo, setsiteInfo] = siteData;

    const [tabsSelected, settabsSelected] = useState(0);
    const [products, setproducts] = useState([]);

    return (
        <div className='mainBoxList'>

            {data?.map((val, k) => {
                
                if (val?.type?.val == 4) {

                    let catList = [];
                    let subCatList = [];
                    val?.data?.map((v, k) => {
                        if (siteInfo?.website?.cat_design?.val) {
                            subCatList.push(v);
                        } else {
                            if (!v?.parent?.val) {
                                catList.push(v);
                    
                                let ck = val?.data?.filter(r => r?.parent?.val == v?._id);
                                ck?.map(v2 => {
                                    subCatList.push(v2);
                                });
                            }
                        }
                    });

                    return (
                        <div className='mainWidth homeCatsBox'>

                            <nav className='tabs'>
                                <Link onClick={() => settabsSelected(0)} className={tabsSelected == 0 ? 'selected' : 'none'}>{t("all_categories")}</Link>
                                {catList?.map((v, k) => {
                                    if (!v?.parent?.val) {
            
                                        let ck = subCatList?.filter(r => r?.parent?.val == v?._id);
                                        
                                        
                                        return (
                                            <Link to={ck?.length ? false : `/cat/${v?._id}`} key={k} onClick={() => ck?.length ? settabsSelected(v?._id) : false} className={tabsSelected == v?._id ? 'selected' : 'none'}>{v?.name}</Link>
                                        )
                                    }
                                })}
                                
                            </nav>
            
                            <ul className='catsMainBox'>
                                {subCatList?.length ? subCatList?.map((v, k) => {
                                    
                                    let show = false;
                                    if (!tabsSelected) {
                                        show = true;
                                    } else if (tabsSelected == v?.parent?.val) {
                                        show = true;
                                    } 
            
                                    if (show) {
                                        return (
                                            <Cats data={v} key={k} />
                                        );
                                    }
                                    
                                }): false}
                            </ul>
            
                        </div>
                    );
                }


                else if (val?.type?.val == 2 || val?.type?.val == 1 || val?.type?.val == 3) {
                    
                    if (val?.data?.length) {
                        return (
                            <div className={`mainWidth homeTopProducts ${val?.data?.length <= 4 && 'mainTop'} themeList_${val?.theme}`}>

                                <div className='titleBox'>
                                    <h4>{val?.name}</h4>
                                    <h5>{val?.full}<hr /></h5>
                                </div>

                                <div className={`productsBox ${val?.data?.length > 4 && 'list5'} `}>
                                    {val?.theme == 1 ?
                                    <Marquee autoFill={true} pauseOnHover={true} gradient={true} gradientWidth={100} direction="right">
                                        {val?.data?.map((v, k) => {
                                        
                                            
                                            // console.log(v);
                                            return (
                                                <Product data={v} key={k} />
                                            );
                                        })}
                                    </Marquee>
                                :
                                    <>
                                    {val?.data?.map((v, k) => {
                                        
                                        return (
                                            <Product data={v} key={k} />
                                        );
                                    })}
                                    </>
                                }
                                    
                                </div>
                    
                            </div>
                        )
                    }
                }
                

            })}
        </div>
    );
}
